// Workflow: sidebar navigation, progress, live activity, trees and media playback.
import '@shoelace-style/shoelace/dist/components/details/details.js'
import '@shoelace-style/shoelace/dist/components/input/input.js'
import '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js'
import '@shoelace-style/shoelace/dist/components/progress-ring/progress-ring.js'
import '@shoelace-style/shoelace/dist/components/tree/tree.js'
import '@shoelace-style/shoelace/dist/components/tree-item/tree-item.js'
import { MediaPlayerController, PrintButtonController, ScrollContainerController } from 'stimulus-library'
import SidebarController from '../../view_components/workflow/sidebar/sidebar'
import NewActivityIndicatorController from './controllers/new_activity_indicator_controller'
import PlaybackController from './controllers/playback_controller'
import TreeExpansionController from './controllers/tree_expansion_controller'

export function register(application) {
  application.register('media-player', MediaPlayerController)
  application.register('print-button', PrintButtonController)
  application.register('scroll', ScrollContainerController)
  application.register('sidebar', SidebarController)
  application.register('activity-monitor', NewActivityIndicatorController)
  application.register('playback', PlaybackController)
  application.register('tree-expansion', TreeExpansionController)
}
